<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('classTeaching.details') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('classTeaching.filter') }}</legend>
                  <div class="row">
                    <div class="col-md-2 text-right">
                      <label class="control-label">{{
                        $t('classTeaching.studentStatus')
                      }}</label>
                    </div>
                    <div class="col-md-3">
                      <select
                        class="form-control"
                        v-model="status_id"
                        @change="fetchDetail"
                      >
                        <option value="">{{ $t('clasSteaching.all') }}</option>
                        <option :value="1">{{
                          $t('clasSteaching.active')
                        }}</option>
                        <option :value="2">{{
                          $t('clasSteaching.dropedOut')
                        }}</option>
                        <option :value="3">{{
                          $t('clasSteaching.suspend')
                        }}</option>
                        <option :value="4">{{
                          $t('clasSteaching.terminated')
                        }}</option>
                      </select>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form>
                <fieldset>
                  <legend>{{ $t('classTeaching.header') }}</legend>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('classTeaching.startDate') }} :
                    </div>
                    <div class="col-md-3">{{ data.start }}</div>
                    <div class="col-md-3 text-right">
                      {{ $t('classTeaching.numberOfStudent') }} :
                    </div>
                    <div class="col-md-3">{{ datasource.length }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('classTeaching.teacherName') }} :
                    </div>
                    <div class="col-md-3">{{ data.teacher }}</div>
                    <div class="col-md-3 text-right">
                      {{ $t('classTeaching.studyTime') }} :
                    </div>
                    <div class="col-md-3">{{ data.time }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('classTeaching.subject') }} :
                    </div>
                    <div class="col-md-3">{{ data.subject }}</div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form>
                <fieldset>
                  <legend>{{ $t('classTeaching.studentLists') }}</legend>
                  <div class="overflow-auto">
                    <table class="table table-hover ui-table ts-table">
                      <thead>
                        <tr>
                          <th style="width:15px" class="text-center">
                            {{ $t('classTeaching.no') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.cardNumber') }}
                          </th>
                          <th class="text-left">
                            {{ $t('classTeaching.studentName') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.sex') }}
                          </th>
                          <th class="text-left">
                            {{ $t('classTeaching.phone') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.discount') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.disType') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.dateFrom') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.dateTo') }}
                          </th>
                          <th class="text-center">
                            {{ $t('classTeaching.paid') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(student, index) in datasource" :key="index">
                          <td class="text-center text-nowrap">
                            {{ index + 1 }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ student.card_number }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{ student.student_name_en }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ student.gender }}
                          </td>
                          <td>{{ student.phone }}</td>
                          <td class="text-center text-nowrap">
                            {{ Math.round(student.discount_rate, 2) }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ student.discount_type }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ student.fee_start_date }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ student.fee_end_date }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ Math.round(student.total_fee, 2) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'previewDetail',
  props: ['data'],
  data() {
    return {
      waiting: false,
      status_id: 1,
      datasource: []
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    fetchDetail() {
      this.waiting = true
      this.$store
        .dispatch('classTeaching/fetchDetail', {
          params: Object.assign({}, this.data, { status_id: this.status_id })
        })
        .then(response => {
          this.datasource = response
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>
